import React from 'react';
import { Box } from '@mui/material';
import LandingHero from './LandingHero';
import LandingBriefInfo from './LandingBriefInfo';
import LandingFooter from './LandingFooter';
import SecurityNavigation from './SecurityNavigation';
import LandingContactInfo from './LandingContactInfo';
import LandingInfoSecurityServices from './LandingInfoSecurityServices';
import LandingExpertTeam from './LandingExpertTeam';
import LandingTechnologiesBanner from './LandingTechnologiesBanner';
import LandingCertificationsStandards from './LandingCertificationsStandards';

export default function Landing() {
  return (
    <Box sx={{ overflow: 'hidden', backgroundColor: 'white' }}>
      <SecurityNavigation />
      <LandingHero />
      <LandingBriefInfo />
      <LandingInfoSecurityServices />
      <LandingTechnologiesBanner />
      <LandingCertificationsStandards />
      <LandingExpertTeam />
      {/*<LandingContact />*/}
      <LandingContactInfo />
      <LandingFooter />
    </Box>
  );
}
